<template>
  <md-card>
    <md-card-header class="md-card-header-icon md-card-header-yellow">
      <div class="card-icon">
        <md-icon>today</md-icon>
      </div>
      <div class="md-layout ">
        <div class="md-layout-item md-size-5"></div>
        <div class="md-layout-item bigfont">
          #{{ activeOrder.mys_extordernumber }},
          {{ activeOrder.billto_name }}
          <span v-if="isSpecialOrder()" class="bigfont" style="color: red;">!<md-tooltip md-direction="right">{{$t("pages.shipments.specialOrderAlert")}}</md-tooltip></span>
        </div>
        <div class="md-layout-item bigfont">
          <template v-if="activeOrder.mys_date_est_send">
            {{ m(activeOrder.mys_date_est_send).format("DD-MM-YY") }}
          </template>
        </div>
      </div>
    </md-card-header>
    <md-card-content>
      <div class="md-layout">
        <div class="md-layout-item md-size-25 deliveryInfo">

          <h3>{{ $t("components.orderview.delivery") }}</h3>
          <div v-if="activeOrder.mys_shiptocompanyname !== ''"> {{ activeOrder.mys_shiptocompanyname }}</div>
          {{ activeOrder.shipto_name }}<br/>
          {{ activeOrder.shipto_line1 }}<br/>
          {{ activeOrder.shipto_postalcode }} {{ activeOrder.shipto_city }}<br/>

          <div class="deliveryInfo">
            <br/><b>{{ $t("components.orderview.servicepoint") }}: 
            {{ displayShippingAgent }}
            </b><br/>
            {{ $t("components.orderview.servicepointid") }}:
            {{ activeOrder.mys_servicepointid }}<br/>
            {{ activeOrder.mys_servicepointname }}<br/>
            {{ activeOrder.mys_servicepointaddress1 }}<br/>
            {{ activeOrder.mys_servicepointzipcode }}
            {{ activeOrder.mys_servicepointcity }}<br/>
          </div>

          <div class="md-layout-item md-size-100" style="white-space: pre-line; padding-right: 15px; padding-left: 0"
               v-bind:class="{lineHighlight : hasNote()}">
            <h3>{{ $t("components.orderview.note") }} </h3>
            <p class="note">
              {{ activeOrder.mys_extnote }}
            </p>
          </div>
          <div v-if="activeOrder.parent" class="md-layout-item md-size-100"
               style="padding-right: 15px; padding-left: 0">
            <h3>
              {{ $t("components.orderview.parent") }}
              {{ activeOrder.parent.name }}
            </h3>
          </div>
        </div>
        <div class="md-layout-item md-size-75">
          <h3>{{ $t("components.orderview.contents") }}
            <OrderReasonHighlighter :order="activeOrder"/>
          </h3>
          <md-table class="table-full-width">
            <md-table-row slot="md-table-row"
                          v-for="line in sortedOrderlines"
                          border="0">
              <md-table-cell md-label="Description" v-bind:class="{lineHighlight : isPropLine(line)}">
                            <span class="md-list-item-text" style="white-space:normal"
                                  v-bind:class="{ strongfont: parseInt(line.quantity) > 1 }">
                                {{ line.quantity }} x
                                {{ line.productdescription }} <b>({{ line.mys_extsku }})</b>
                            </span>
              </md-table-cell>
              <md-table-cell md-label="Pairing">
                <div v-show="isDeviceLine(line) || isMygreetingsLine(line) || isPrinterLine(line)">
                  <div v-for="n in parseInt(line.quantity)">
                    <a v-if="!isValidDevice(activeOrder, line, n)"
                       v-on:click="openOrder();"
                       class="md-button md-raised md-success md-theme-default">

                      <div class="md-ripple">
                        <div class="md-button-content"><i class="far fa-plus-square fa-3x"></i>&nbsp;&nbsp;
                          {{ $t("buttons.pairdevice") }}
                        </div>
                      </div>

                    </a>
                    <br/>
                    <br/>
                    <md-button v-if="isValidDevice(activeOrder, line, n)"
                               v-on:click="removeDevice(activeOrder, n)"
                               class="md-raised">
                      <i class="far fa-minus-square"></i>&nbsp;&nbsp;
                      {{ $t("buttons.removedevice") }}
                      ({{ getDevice(activeOrder, line, n).mys_nummer }})
                    </md-button>
                  </div>
                </div>
              </md-table-cell>
            </md-table-row>
          </md-table>
        </div>

        <div class="md-layout-item md-size-75">
          <md-button v-bind:disabled="!readyForLabel()"
                     v-on:click="completeOrder()"
                     class="md-raised"
                     v-bind:class="{ 'md-success': readyForLabel() }">
            <i class="fas fa-shipping-fast"></i>&nbsp;&nbsp;
            {{ $t("buttons.fulfillorder") }}
          </md-button>
        </div>
        <div class="md-layout-item md-size-75">
          <md-button v-on:click="printExtraLabel(5)"
                     class="md-raised"
                     v-bind:disabled="isRunning || !activeWarehousePrinterId">
            <i class="fas fa-tag"></i>&nbsp;&nbsp;
            Print 5 kg label
          </md-button>
          <md-button v-on:click="printExtraLabel(10)"
                     class="md-raised"
                     v-bind:disabled="isRunning || !activeWarehousePrinterId">
            <i class="fas fa-tag"></i>&nbsp;&nbsp;
            Print 10 kg label
          </md-button>
          <md-button v-on:click="printExtraLabel(20)"
                     class="md-raised"
                     v-bind:disabled="isRunning || !activeWarehousePrinterId">
            <i class="fas fa-tag"></i>&nbsp;&nbsp;
            Print 20 kg label
          </md-button>
        </div>
        <div class="md-layout-item md-size-100">
          <md-progress-bar md-mode="indeterminate"
                           class="md-accent"
                           v-if="isRunning"></md-progress-bar>
        </div>

      </div>
    </md-card-content>
  </md-card>
</template>
<script>
import {mapGetters} from 'vuex';
import moment from "moment";
import Swal from "sweetalert2";
import apiService from "../../../../services/APIService";
import keyboardBufferMixin from "@/Mixins/keyboardBufferMixin";
import store from "@/store";
import OrderReasonHighlighter from "@/pages/Dashboard/Shipping/Components/OrderReasonHighlighter";

export default {
  components: {OrderReasonHighlighter},
  props: ["activeOrder"],
  mixins: [keyboardBufferMixin],
  data() {
    return {
      m: moment,
      isRunning: false,
    };
  },
  computed: {
    ...mapGetters(["activeWarehousePrinterId"]),
    sortedOrderlines() {
      if (!this.activeOrder || !this.activeOrder.orderProducts) return;
      return this.activeOrder.orderProducts.sort((a, b) => {
        if (a.mys_sortorder < b.mys_sortorder) return -1;
        else return 1;
      });
    },
    displayShippingAgent() {
      return this.activeOrder.mys_servicepointshippingagent || this.$t("components.orderview.unknownshippingagent");
    }
  },
  methods: {
    keyPress() {
      if (event.keyCode === 13) {
        this.keyBuffer = [];
        var buf = this.keyBoardBuffer.trim();

        if (this.isNumeric(buf)) {
          switch (buf) {
            case "99999":
              this.completeOrder();
              break;
            default:
              this.openOrder(buf);
          }
        }
        this.keyBoardBuffer = '';
      } else {

        var t = (new Date()).getTime();
        var k = event.keyCode;
        this.keyBuffer.push({k, t})
        this.keyBuffer = this.keyBuffer.filter(kt => t - kt.t < 200);
        this.keyBoardBuffer = this.keyBuffer.map(kt => this.keyCodeMap[kt.k]).join("");

      }

    },
    isSpecialOrder() {
      return this.activeOrder.orderProducts.some(op => 
        !op.mys_extsku.startsWith("M-") && op.mys_extsku !== "FPK" && op.mys_extsku !== "AKT"
      );
    },
    containsMygreetings() {
      return this.activeOrder.orderProducts.some(op => op.mys_extsku === "MYG");
    },
    hasNote() {
      return this.activeOrder.mys_extNote && this.activeOrder.mys_extnote !== "";
    },
    isPropLine(line) {
      return false;
      return line.mys_extsku.startsWith("P") && line.mys_extsku !== "P31";
    },
    completeOrder() {

      if (this.isRunning)
        return;


      if (!this.activeOrder || !this.activeOrder._mys_OwningAccount_value)
        return;

      if(!this.readyForLabel()) {
        Swal.fire({
          title: this.$t(
            "components.orderview.dialogs.fulfill.notreadyforlabel.title"
          ),
          text: this.$t(
            "components.orderview.dialogs.fulfill.notreadyforlabel.message"
          ),
          timer: 3500,
          type: "error",
          icon: "warning",
          showConfirmButton: false,
        });
        return;
      }
      this.isRunning = true;
      apiService
          .postApi(
              `/portals/v1/accounts/${this.activeOrder._mys_OwningAccount_value}/shipments/${this.activeOrder.salesorderid}/warehouseprinters/${this.activeWarehousePrinterId}/complete`,
              null
          )
          .then((response) => {
            // Tell the parent this removal is expected so it does not warn.
            this.$emit("order-completed", this.activeOrder.salesorderid);
            store.dispatch("loadWarehouseShipments");
            this.isRunning = false;
            this.activeOrder.statecode = 3;
            
            Swal.fire({
              title: this.$t(
                  "components.orderview.dialogs.fulfill.confirmation.title"
              ),
              text: this.$t(
                  "components.orderview.dialogs.fulfill.confirmation.message"
              ),
              timer: 1500,
              icon: "success",
              showConfirmButton: false,
            });
          })
          .catch((error) => {

            this.isRunning = false;
            
            if(error.response && error.response.data)
            {
              Swal.fire({
                title: "Ordre kunne ikke gennemføres",
                text: error.response.data.message ? error.response.data.message : error.response.data.Message,
                type: "error",
              });
            }
            store.dispatch("loadWarehouseShipments")
          });
    },
    printExtraLabel(weightKg) {
      if (this.isRunning) return;
      if (!this.activeOrder || !this.activeOrder._mys_OwningAccount_value) return;

      this.isRunning = true;
      apiService
          .postApi(
              `/portals/v1/accounts/${this.activeOrder._mys_OwningAccount_value}/shipments/${this.activeOrder.salesorderid}/warehouseprinters/${this.activeWarehousePrinterId}/extralabel/${weightKg}`,
              null
          )
          .then(() => {
            Swal.fire({
              title: `${weightKg} kg label sendt til printeren`,
              icon: "success",
              timer: 2000,
              showConfirmButton: false,
            });
          })
          .catch((error) => {
            Swal.fire({
              title: "Label kunne ikke printes",
              text: error.response && error.response.data ? (error.response.data.message || error.response.data.Message) : "",
              icon: "error",
            });
          })
          .finally(() => {
            this.isRunning = false;
          });
    },
    removeDevice(order, n) {
      if (n > 1) return;


      var deviceToBeRemoved = order.orderDevices[n - 1];


      Swal.fire({
        title: 'Bekræft unpairing',
        text: `Vil du fjerne enheden ${deviceToBeRemoved.mys_nummer} fra ordren ${order.mys_extordernumber} igen?`,
        icon: 'warning',
        showCancelButton: true,
        focusCancel: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Ja, fjern enheden!'
      }).then((result) => {


        if (result.value) {

          apiService
              .deleteApi(
                  `/portals/v1/accounts/${this.activeOrder._mys_OwningAccount_value}/orders/${this.activeOrder.salesorderid}/devices/${deviceToBeRemoved.mys_orderdeviceid}`
              )
              .then((response) => {
                if (response.status !== 200) {
                  throw new Error(response.statusText);
                }
                order.orderDevices.splice(n - 1);


                Swal.fire(
                    {
                      title: this.$t(
                          "components.orderview.dialogs.removepairing.confirmation.title"
                      ), text: this.$t(
                          "components.orderview.dialogs.removepairing.confirmation.message"
                      ), type: "success", timer: 1500
                    }
                );
              });

        }
      })
    },
    readyForLabel() {
      if (!this.activeOrder || !this.activeOrder.orderProducts || !this.activeWarehousePrinterId) return false;

      var deviceLines = this.activeOrder.orderProducts.filter(
          (l) => l.mys_extsku && l.mys_extsku.startsWith("M-")
      );
      var mygreetingsLines = this.activeOrder.orderProducts.filter(
          (l) => l.mys_extsku && l.mys_extsku.startsWith("MYG")
      );
      var printerLines = this.activeOrder.orderProducts.filter(
        (l) => l.mys_extsku && this.isPrinterLine(l)
      );

      if ((!deviceLines || deviceLines.length === 0) && 
          (!mygreetingsLines || mygreetingsLines.length === 0) &&
          (!printerLines || printerLines.length === 0)) {
        return true;
      }    

      var numberOfDevicesNeeded = deviceLines
          .map((e) => {
            return parseInt(e.quantity);
          })
          .reduce((a, b) => a + b, 0);
      var numberOfMygreetingsNeeded = mygreetingsLines
          .map((e) => {
            return parseInt(e.quantity);
          })
          .reduce((a, b) => a + b, 0);
      var numberOfPrintersNeeded = printerLines
        .map((e) => parseInt(e.quantity))
        .reduce((a, b) => a + b, 0);

      if (numberOfDevicesNeeded === 0 && numberOfMygreetingsNeeded === 0 && numberOfPrintersNeeded === 0) {
        return true;
      }
      
      if (!this.activeOrder.orderDevices) return false;
      var numberOfDevicesPaired = this.activeOrder.orderDevices.filter(od => parseInt(od.mys_nummer) < 10000 ).length
      var numberOfMygreetingsPaired = this.activeOrder.orderDevices.filter(od => parseInt(od.mys_nummer) >= 10000 && parseInt(od.mys_nummer) < 20000).length
      var numberOfPrintersPaired = this.activeOrder.orderDevices.filter(od => parseInt(od.mys_nummer) >= 20000 && parseInt(od.mys_nummer) < 30000).length;

      return (
        numberOfDevicesPaired >= numberOfDevicesNeeded &&
        numberOfMygreetingsPaired >= numberOfMygreetingsNeeded &&
        numberOfPrintersPaired >= numberOfPrintersNeeded
      );
    },
    openOrder(deviceNumber) {
      if (this.isRunning) return;

      if (this.readyForLabel()) {
        this.completeOrder();
        return;
      }

      if (!this.activeOrder || !this.activeOrder._mys_OwningAccount_value)
        return;

      var pairedOrderDeviceName = "";
      if (deviceNumber && this.isNumeric(deviceNumber) && deviceNumber !== 99999) {

        this.isRunning = true;

        apiService
            .putApi(
                `/portals/v1/accounts/${this.activeOrder._mys_OwningAccount_value}/orders/${this.activeOrder.salesorderid}/device`,
                {DeviceNumber: deviceNumber}
            )
            .then((response) => {
              this.activeOrder.orderDevices.push({
                mys_nummer: parseInt(deviceNumber),
                mys_orderdeviceid: response.data.mys_orderdeviceid,
              });

              pairedOrderDeviceName = response.data.mys_name;

              Swal.fire({
                title: this.$t(
                    "components.orderview.dialogs.pairing.confirmation.title"
                ), text: `${this.$t(
                    "components.orderview.dialogs.pairing.confirmation.message"
                )} ${pairedOrderDeviceName}`, type: "success", timer: 3500
              });
            })
            .catch((error) => {
              var errorText = this.$t(
                  error.response.data.message ? error.response.data.message : error.response.data.Message
              );

              Swal.fire({
                type: 'error',
                title: 'Fejl ved parring',
                text: errorText
              })
              
            }).finally(() => {
              // This will run after either the promise is resolved or rejected.
              this.isRunning = false;
              store.dispatch("loadWarehouseShipments");
            });

      } else {
        this.isRunning = true;
        Swal.fire({
          title: this.$t("components.orderview.dialogs.pairing.title"),
          input: "text",
          inputPlaceholder: "122",
          inputAttributes: {
            autocapitalize: "off",
          },
          showCancelButton: true,
          cancelButtonText: this.$t("buttons.cancel"),
          confirmButtonText: this.$t("buttons.pairdevice"),
          preConfirm: (number) => {
            return apiService
                .putApi(
                    `/portals/v1/accounts/${this.activeOrder._mys_OwningAccount_value}/orders/${this.activeOrder.salesorderid}/device`,
                    {DeviceNumber: number}
                )
                .then((response) => {

                  this.activeOrder.orderDevices.push({
                    mys_nummer: number,
                    mys_orderdeviceid: response.data.mys_orderdeviceid,
                  });

                  pairedOrderDeviceName = response.data.mys_name;


                  return true;
                })
                .catch((error) => {

                  this.isRunning = false;
                  let errorText = this.$t(
                      error.response.data.message ? error.response.data.message : error.response.data.Message
                  );


                  Swal.showValidationMessage(errorText);
                });
          },
          allowOutsideClick: () => !Swal.isLoading(),
        }).then((result) => {
          this.isRunning = false;
          if (result.value) {
            Swal.fire({
              title: this.$t(
                  "components.orderview.dialogs.pairing.confirmation.title"
              ),
              text: `${this.$t("components.orderview.dialogs.pairing.confirmation.message")} ${pairedOrderDeviceName}`,
              type: "success",
              timer: 3500
            });

          }
        });
      }
    },
    getDevice(order, line, i) {
      if (!order.orderDevices) return null;

      if(this.isMygreetingsLine(line)) {
        var orderDevices = order.orderDevices.filter(od => parseInt(od.mys_nummer) >= 10000 && parseInt(od.mys_nummer) < 20000)
        if (!orderDevices[i - 1]) return null;
        else return orderDevices[i - 1];
      } else if(this.isPrinterLine(line)) {
        var orderDevices = order.orderDevices.filter(od => parseInt(od.mys_nummer) >= 20000 && parseInt(od.mys_nummer) < 30000)
        if (!orderDevices[i - 1]) return null;
        else return orderDevices[i - 1];
      } else if(this.isDeviceLine(line)) {
        var orderDevices = order.orderDevices.filter(od => parseInt(od.mys_nummer) < 10000)
        if (!orderDevices[i - 1]) return null;
        else return orderDevices[i - 1];
      }
      return null;
    },
    isValidDevice(activeOrder, line, i) {
      const device = this.getDevice(activeOrder, line, i);
      if (device === null) return false;  // Immediately return false if device is null

      const isMygreetingsCondition = device.mys_nummer >= 10000 && device.mys_nummer < 20000 && this.isMygreetingsLine(line);
      const isPrinterCondition = device.mys_nummer >= 20000 && device.mys_nummer < 30000 && this.isPrinterLine(line);
      const isDeviceLineCondition = device.mys_nummer < 10000 && this.isDeviceLine(line);
      return isMygreetingsCondition || isDeviceLineCondition || isPrinterCondition;
    },
    isDeviceLine(line) {
      if (!line.mys_extsku) return false;
      return line.mys_extsku.startsWith("M-");
    },
    isMygreetingsLine(line) {
      if (!line.mys_extsku) return false;
      return line.mys_extsku.toUpperCase() === "MYG"
    },
    isPrinterLine(line) {
      if (!line.mys_extsku) return false;
      return line.mys_extsku.startsWith("MYP");
    }
  },
  created() {
    document.addEventListener("keyup", this.keyPress);
  }
};
</script>
<style>
.md-table-cell {
  font-size: 20px;
}

.strongfont {
  font-weight: bold;
}

.bigfont {
  font-size: xxx-large;
  line-height: 1em;
  font-weight: bolder;
}

.spinnercell {
  padding-top: 5px;
  xtext-align: right;
}

.deliveryInfo {
  font-size: 18px;
}

.note {
  font-size: 18px;
  font-weight: 600;
  color: red;
}

.lineHighlight {
  background-color: #b8ecf3;
}

</style>
